import React from 'react';

import { Skeleton } from '@atlassian/eoc-skeleton';

import { NowLocation } from '../../../../../utils/constants/schedule';
import { TimeDisplay } from '../../constants';
import { type LoadingProps } from '../../types';
import { Cell, Container, EmptyTime, Header, Inner, Line, List } from '../styled';

const LayerLoading = ({ numberOfDays, children, variant, size }: LoadingProps) => {
	const sectionCount = numberOfDays === 1 ? 4 : numberOfDays;

	return (
		<Container>
			{Array.from({ length: sectionCount }).map((_, i) => (
				<Line variant={variant} ratio={100 / sectionCount} index={i} key={i} />
			))}

			<Header>
				{variant === 'full' && <EmptyTime />}

				<Inner>
					{Array.from({ length: sectionCount }).map((_, i) => {
						return (
							<Cell
								variant={variant}
								ratio={100 / sectionCount}
								display={TimeDisplay.VerticalDay}
								key={i}
								nowLocation={NowLocation.After}
							>
								<Skeleton height={1} width={3.25} />
							</Cell>
						);
					})}
				</Inner>
			</Header>

			<List size={size}>{children}</List>
		</Container>
	);
};

export { LayerLoading };
